import { render, staticRenderFns } from "./BaseTopBar.vue?vue&type=template&id=63e57d85&scoped=true&"
import script from "./BaseTopBar.vue?vue&type=script&lang=js&"
export * from "./BaseTopBar.vue?vue&type=script&lang=js&"
import style0 from "./BaseTopBar.vue?vue&type=style&index=0&id=63e57d85&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e57d85",
  null
  
)

export default component.exports